import { useQueryParam } from "hooks"

/**
 * New Journey navigation should be handled with search params.
 */
export const useJourneyNavigation = () => {
  const [journeyIdParam, setJourneyIdParam] = useQueryParam("journeyId")

  const navigateToJourney = (journeyId: string | undefined) => {
    setJourneyIdParam(journeyId)
    window.scrollTo(0, 0)
  }

  return { journeyIdParam, navigateToJourney }
}
